/**
 * Panel — research's binding of the shared floating panel.
 *
 * The component lives in `shared/surface/Panel`; research supplies the resize
 * bounds for its own panel ids so call sites here stay unchanged.
 */

import React from 'react';
import SharedPanel, { PanelAction, PanelDropZone } from '../../shared/surface/Panel';
import { PANEL_BOUNDS, PanelId } from './layout';

type SharedProps = React.ComponentProps<typeof SharedPanel>;
type Props = Omit<SharedProps, 'id' | 'bounds'> & { id: PanelId };

const Panel: React.FC<Props> = ({ id, ...rest }) => (
  <SharedPanel id={id} bounds={PANEL_BOUNDS[id]} {...rest} />
);

export { PanelAction, PanelDropZone };
export default Panel;
